<template>
  <div class="warranty-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="page-header-content">
        <img src='@/assets/head2.png'>
      </div>
    </div>

    <!-- 质保卡列表 -->
    <div class="warranty-list">
      <div 
        class="warranty-card" 
        v-for="(card, index) in warrantyCards" 
        :key="index"
        :class="{'expanded': card.expanded}"
        @click="toggleCard(index)"
      >
        <!-- 简要信息 -->
        <div class="card-summary">
          <div class="project-info">
            <h2>{{ card.projectName }}</h2>
            <p>{{ card.projectAddress }}</p>
            <div class="warranty-number" @click.stop="copyWarrantyNumber(card.warrantyNumber)">
              <span>质保编号: {{ card.warrantyNumber }}</span>
              <svg viewBox="0 0 24 24" class="copy-icon">
                <path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
              </svg>
            </div>
          </div>
          <div class="status-tag">
            <el-tag :type="card.status === '在保中' ? 'success' : 'info'">
              {{ card.status }}
            </el-tag>
          </div>
        </div>

        <!-- 展开后的详细信息 -->
        <div class="card-details" v-if="card.expanded">
          <!-- 质保内容 -->
          <div class="warranty-content">
            <h3>质保内容</h3>
            <div class="content-list">
              <div class="content-item" v-for="(item, i) in card.warrantyItems" :key="i">
                <div class="item-name">{{ item.name }}</div>
                <div class="item-date">{{ item.startDate }} 至 {{ item.endDate }}</div>
              </div>
            </div>
          </div>

          <!-- 效果图 -->
          <div class="effect-images">
            <h3>完工效果</h3>
            <div class="image-grid">
              <div 
                class="image-item" 
                v-for="(img, imgIndex) in card.effectImages" 
                :key="imgIndex"
                :style="{backgroundImage: `url(${img})`}"
                @click.stop="showImagePreview(card.effectImages, imgIndex)"
              ></div>
            </div>
          </div>

          <div class="after-sales-store">
            <h3>售后门店</h3>
            <div class="store-info">
              <div class="info-item">
                <svg viewBox="0 0 24 24" class="info-icon">
                  <path fill="currentColor" d="M12,3A4,4 0 0,0 8,7A4,4 0 0,0 12,11A4,4 0 0,0 16,7A4,4 0 0,0 12,3M12,13C7.04,13 3,16 3,20V21H21V20C21,16 16.96,13 12,13Z" />
                </svg>
                <span>领班人广告连锁({{ card.storeName || '上海总店' }})</span>
              </div>
              <div class="info-item">
                <svg viewBox="0 0 24 24" class="info-icon">
                  <path fill="currentColor" d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
                </svg>
                <span>{{ card.storeAddress || '上海市浦东新区张江高科技园区科苑路88号' }}</span>
              </div>
            </div>
          </div>

          <!-- 公章和声明 -->
          <div class="official-seal">
            <div class="seal-image">
              
            </div>
            <p class="seal-text">本产品由领班人广告连锁提供质量保证</p>
          </div>

          <!-- 合同信息按钮 -->
          <div class="contract-info">
            <el-button type="primary" plain @click.stop="viewContract(card)">
              查看合同信息
            </el-button>
          </div>
        </div>
      </div>

      <div id="contact" class="mobile-section">
        <div class="section-title-container">
          <div class="section-title-block"></div>
          <h2 class="section-title">全国联保热线</h2>
          <h2 class="section-title-en">Contact Number</h2>
        </div>
        <div class="contact-info">
          <div class="info-item">
            <img src="@/assets/phonenum.png">
          </div>
        </div>
        <button class="contact-btn" @click="makeCall">
          <span>一键拨打电话</span>
        </button>
      </div>

    </div>


    <!-- 图片预览弹窗 -->
    <el-dialog 
    :visible.sync="imagePreviewVisible" 
    :fullscreen="isMobile"
    top="5vh"
    width="auto"
    custom-class="image-preview-dialog"
    :close-on-click-modal="false"
    @close="closeImagePreview"
  >
    <div class="preview-container">
      <el-carousel 
        ref="carousel" 
        :autoplay="false" 
        :initial-index="previewImageIndex"
        indicator-position="outside"
        :height="carouselHeight"
      >
        <el-carousel-item v-for="(img, index) in previewImages" :key="index">
          <div class="carousel-image" :style="{backgroundImage: `url(${img})`}"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </el-dialog>

  <!-- 合同预览对话框 -->
    <el-dialog 
      title="合同预览"
      :visible.sync="previewDialogVisible"
      :close-on-click-modal="false"
      width="90%"
      top="5vh"
      fullscreen
    >
      <div v-if="previewType === 'pdf'" class="pdf-viewer-container">
        <!-- 工具栏 -->
        <div class="pdf-toolbar">
          <el-button-group>
            <el-button 
              size="small" 
              @click="zoomOut" 
              :disabled="pdfInfo.scale <= 0.5"
            >
              <i class="el-icon-zoom-out"></i> 缩小
            </el-button>
            <el-button size="small">
              缩放: {{ (pdfInfo.scale * 100).toFixed(0) }}%
            </el-button>
            <el-button 
              size="small" 
              @click="zoomIn" 
              :disabled="pdfInfo.scale >= 2.0"
            >
              <i class="el-icon-zoom-in"></i> 放大
            </el-button>
          </el-button-group>
          
          <div class="page-count">
            共 {{ pdfInfo.pages.length }} 页
          </div>
        </div>
        
        <!-- PDF页面容器 -->
        <div class="pdf-pages-container" ref="pdfPages">
          <div v-if="pdfInfo.loading" class="loading-tip">
            <i class="el-icon-loading"></i>
            <span>正在渲染PDF页面...</span>
          </div>
        </div>
      </div>

      <div v-else-if="previewType === 'docx'" class="docs-preview-container">
        <vue-office-docx 
          :src="previewUrl" 
          style="height: 80vh;"
        />
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewDialogVisible = false">关闭</el-button>
        <!-- <el-button 
          type="primary" 
          @click="downloadContract({contract: previewUrl})"
        >
          下载
        </el-button> -->
      </div>
    </el-dialog>

  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx'
import * as pdfjsLib from 'pdfjs-dist/webpack'
import {getCustomer} from '../api/mobile'

export default {
  name: 'WarrantyCard',
  components: {
    VueOfficeDocx,
  },
  data() {
    return {
      warrantyCards: [],
      imagePreviewVisible: false,
      previewImages: [],
      previewImageIndex: 0,
      isMobile: false,
      carouselHeight: 'auto',
      imageStyle: {
        maxWidth: '100%',
        maxHeight: '80vh',
        width: 'auto',
        height: 'auto'
      },
      imageNaturalSize: {
        width: 0,
        height: 0
      },
      previewDialogVisible:false,
      previewUrl:"http://lbrapi.gcaibang.com/uploads/contracts/1752406176662692836.pdf",
      previewType:"pdf",
      pdfInfo: {
        pages: [],     // 存储所有页面
        scale: 1.0,    // 默认缩放比例
        pdfDoc: null,  // PDF文档对象
        loading: false // 加载状态
      },
    }
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
    this.GetCustomerInfo();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  methods: {
    GetCustomerInfo(){
      getCustomer().then(res=>{
        if(res.code == 1)
        {
          this.warrantyCards = []
          res.data.Cards.forEach(element => {
            let content = JSON.parse(element.Content)
            let images = JSON.parse(element.ImageURL)
            var wrarantItems = []
            var status = '已过期'
            var effectImgs = []
            var now = new Date()
            content.forEach(item=>{
              wrarantItems.push({
                name:item.content,
                startDate: item.starTime,
                endDate:item.endTime
              })
              var end = new Date(item.endTime)
              if(now <= end){
                status = '在保中'
              }

            })

            images.forEach(item=>{
              if(item !== "")
              {
                effectImgs.push(process.env.VUE_APP_BASE_API + "/uploads/" + item)
              }
            })

            this.warrantyCards.push({
              warrantyNumber:element.CardNumber,
              projectName:element.Name,
              projectAddress:element.Address,
              storeName:element.WarrantyShop,
              storeAddress:element.WarrantyShopAddress,
              warrantyItems:wrarantItems,
              status:status,
              contract: element.FileURL !== "" ?  process.env.VUE_APP_BASE_API + "/uploads/" + element.FileURL : "", 
              effectImages:effectImgs,
              expanded:false
            })
          });
        }


      }).catch(err => {
        console.error(err)
      })
    },
    toggleCard(index) {
      this.warrantyCards[index].expanded = !this.warrantyCards[index].expanded;
    },
    viewContract(card) {
      this.fileUrl = card.contract
      this.previewContract({contract:card.contract})
    },
    showImagePreview(images, index) {
      this.previewImages = images;
      this.previewImageIndex = index;
      this.imagePreviewVisible = true;
      this.adjustImageDisplay();
    },
    closeImagePreview() {
      this.imagePreviewVisible = false;
      this.previewImages = [];
      this.previewImageIndex = 0;
    },
    handleImageLoad(event) {
      const img = event.target;
      this.imageNaturalSize = {
        width: img.naturalWidth,
        height: img.naturalHeight
      };
      
      // 根据图片实际尺寸调整显示方式
      this.adjustImageDisplay();
    },
    adjustImageDisplay() {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const { width: imgWidth, height: imgHeight } = this.imageNaturalSize;
      
      // 计算最大可用高度（保留顶部和底部空间）
      const maxAvailableHeight = windowHeight * 0.8;
      const maxAvailableWidth = windowWidth * 0.9;
      
      // 计算图片比例
      const imgRatio = imgWidth / imgHeight;
      const windowRatio = maxAvailableWidth / maxAvailableHeight;
      
      // 根据图片比例决定显示方式
      if (imgRatio > windowRatio) {
        // 宽图，以宽度为基准
        this.imageStyle = {
          maxWidth: `${maxAvailableWidth}px`,
          maxHeight: `${maxAvailableWidth / imgRatio}px`,
          width: 'auto',
          height: 'auto'
        };
        this.carouselHeight = `${maxAvailableWidth / imgRatio}px`;
      } else {
        // 高图，以高度为基准
        this.imageStyle = {
          maxWidth: `${maxAvailableHeight * imgRatio}px`,
          maxHeight: `${maxAvailableHeight}px`,
          width: 'auto',
          height: 'auto'
        };
        this.carouselHeight = `${maxAvailableHeight}px`;
      }
    },
    copyWarrantyNumber(number) {
      navigator.clipboard.writeText(number).then(() => {
        this.$message({
          message: '质保编号已复制',
          type: 'success',
          duration: 1500
        });
      }).catch(err => {
        console.error('复制失败:', err);
        this.$message.error('复制失败');
      });
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth < 768;
      if (this.imagePreviewVisible) {
        this.adjustImageDisplay();
      }
    },
    makeCall() {
      window.location.href = 'tel:400-6920-220';
    },

    previewContract(row) {
      if (!row.contract) {
        this.$message.warning('该客户没有上传合同文件');
        return;
      }
      
      const fileUrl = row.contract;
      const fileExt = fileUrl.split('.').pop().toLowerCase();
      
      if (fileExt === 'pdf') {
        this.previewPdf(fileUrl);
      } else if (fileExt === 'docx' || fileExt === 'doc') {
        this.previewDocx(fileUrl);
      } else {
        this.$message.warning('不支持的文件格式，仅支持PDF和Word文档');
        return;
      }
    },

    previewDocx(url) {
      this.previewType = 'docx';
      this.previewUrl = url;
      this.previewDialogVisible = true;
    },

    async previewPdf(url) {
      try {
        // 初始化状态
        this.previewType = 'pdf';
        this.previewUrl = url;
        this.previewDialogVisible = true;
        this.pdfInfo.loading = true;
        this.pdfInfo.pages = [];
        
        // 等待对话框渲染
        await this.$nextTick();
        
        // 加载PDF.js
        if (!window.pdfjsLib) {
          await this.loadPdfJs();
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        // 加载PDF文档
        const loadingTask = pdfjsLib.getDocument(url);
        this.pdfInfo.pdfDoc = await loadingTask.promise;
        
        // 清空容器
        this.$refs.pdfPages.innerHTML = '';
        
        // 渲染所有页面
        for (let i = 1; i <= this.pdfInfo.pdfDoc.numPages; i++) {
          await this.renderPdfPage(i);
        }
        
      } catch (error) {
        console.error('PDF预览失败:', error);
        this.$message.error(`预览失败: 浏览器版本过低`);
      } finally {
        this.pdfInfo.loading = false;
      }
    },

    async renderPdfPage(pageNum) {
      try {
        // 获取PDF页面
        const page = await this.pdfInfo.pdfDoc.getPage(pageNum);
        const viewport = page.getViewport({ scale: this.pdfInfo.scale });
        
        // 创建canvas
        const canvas = document.createElement('canvas');
        canvas.className = 'pdf-page-canvas';
        const context = canvas.getContext('2d');
        
        // 设置canvas尺寸
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        
        // 渲染页面
        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;
        
        // 添加到DOM
        this.$refs.pdfPages.appendChild(canvas);
        
        // 添加页面间距
        const spacer = document.createElement('div');
        spacer.className = 'page-spacer';
        this.$refs.pdfPages.appendChild(spacer);
        
        // 存储页面信息
        this.pdfInfo.pages.push({
          number: pageNum,
          canvas: canvas,
          height: viewport.height
        });
        
      } catch (error) {
        console.error(`渲染第${pageNum}页失败:`, error);
      }
    },

    async startRenderVisiblePages() {
      // 计算可见区域
      const container = this.$refs.pdfContainer;
      const scrollTop = container.scrollTop;
      const viewportHeight = container.clientHeight;
      
      // 查找需要渲染的页面范围
      let startPage = 0, endPage = 0;
      let accumulatedHeight = 0;
      
      for (let i = 0; i < this.pdfInfo.pages.length; i++) {
        const page = this.pdfInfo.pages[i];
        if (!page.rendered) {
          if (accumulatedHeight <= scrollTop + viewportHeight * 2 && 
              accumulatedHeight + (page.height || 1000) >= scrollTop - viewportHeight) {
            if (startPage === 0) startPage = i;
            endPage = i;
          }
        }
        accumulatedHeight += page.height || 1000;
      }
      
      // 渲染可见页面
      for (let i = startPage; i <= endPage; i++) {
        if (!this.pdfInfo.pages[i].rendered) {
          await this.renderPdfPage(i + 1); // 页面编号从1开始
        }
      }
    },

    async zoomIn() {
      this.pdfInfo.scale += 0.1;
      await this.rerenderAllPages();
    },
    
    async zoomOut() {
      if (this.pdfInfo.scale > 0.5) {
        this.pdfInfo.scale -= 0.1;
        await this.rerenderAllPages();
      }
    },
    async rerenderAllPages() {
      if (!this.pdfInfo.pdfDoc) return;
      
      this.pdfInfo.loading = true;
      try {
        // 清空容器
        this.$refs.pdfPages.innerHTML = '';
        this.pdfInfo.pages = [];
        
        // 重新渲染所有页面
        for (let i = 1; i <= this.pdfInfo.pdfDoc.numPages; i++) {
          await this.renderPdfPage(i);
        }
      } finally {
        this.pdfInfo.loading = false;
      }
    },
  

    cleanupPdf() {
      // 清理资源
      if (this.pdfInfo.pdfDoc) {
        this.pdfInfo.pdfDoc.destroy();
      }
      this.pdfInfo = {
        pages: [],
        scale: 1.0,
        pdfDoc: null,
        loading: false
      };
    },
  }
}
</script>

<style scoped>
/* 基础样式 */
.warranty-page {
  padding: 0px;
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* 页面标题 */
.page-header {
  margin-bottom: 10px;
  text-align: center;
  background-color: rgb(238, 238, 238);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.page-header-content{
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-header-content img{
  width: 100%;
  height: auto;
  object-fit: contain;
}

.page-image-logo{
  width: 60px;
  height: 60px;
}


.page-tips{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 15px;
}

.page-subtitle {
  font-size: 16px;
  color: #012db2;
  margin: 0;
  opacity: 0.8;
}

/* 质保卡列表 */
.warranty-list {
  display: flex;
  flex-direction: column;
  padding: 5px;
  gap: 15px;
}

/* 质保卡样式 */
.warranty-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #ffec01;
}

.warranty-card.expanded {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

/* 简要信息 */
.card-summary {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.project-info h2 {
  font-size: 16px;
  color: #012db2;
  margin: 0 0 5px 0;
  font-weight: 600;
}

.project-info p {
  font-size: 13px;
  color: #012db2;
  margin: 0;
}

.status-tag {
  flex-shrink: 0;
}

/* 详细信息 */
.card-details {
  padding: 0 15px 15px;
  border-top: 1px solid #f0f2f5;
}

/* 质保内容 */
.warranty-content {
  margin-top: 15px;
}

.warranty-content h3 {
  font-size: 15px;
  color: #012db2;
  margin: 0 0 10px 0;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.warranty-content h3::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #ffec01;
  margin-right: 8px;
  border-radius: 2px;
}

.content-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.content-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #ffec01;
  border-radius: 8px;
}

.item-name {
  font-size: 14px;
  color: #012db2;
  font-weight: 500;
}

.item-date {
  font-size: 13px;
  color: #012db2;
}

/* 效果图 */
.effect-images {
  margin-top: 20px;
}

.effect-images h3 {
  font-size: 15px;
  color: #012db2;
  margin: 0 0 10px 0;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.effect-images h3::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #ffec01;
  margin-right: 8px;
  border-radius: 2px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.image-item {
  height: 100px;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s;
}

.image-item:hover {
  transform: scale(1.02);
}

/* 公章区域 */
.official-seal {
  margin-top: 20px;
  text-align: center;
  padding: 15px 0;
  border-top: 1px dashed #e0e3e8;
  border-bottom: 1px dashed #e0e3e8;
}

.seal-image {
  width: 120px;
  height: 120px;
  margin: 0 auto 10px;
  background-image: url('@/assets/gongzhang.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.seal-text {
  font-size: 13px;
  color: #606266;
  margin: 10px 0 0;
}

/* 合同信息按钮 */
.contract-info {
  margin-top: 20px;
  text-align: center;
}

/* 图片预览弹窗样式 */
.image-preview-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.image-preview-dialog .el-dialog__header {
  display: none;
}

.preview-container {
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-carousel {
  width: 100%;
  height: 100%;
}

.carousel-image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}


/* 售后门店信息 */
.after-sales-store {
  margin-top: 20px;
}

.after-sales-store h3 {
  font-size: 15px;
  color: #012db2;
  margin: 0 0 10px 0;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.after-sales-store h3::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #ffec01;
  margin-right: 8px;
  border-radius: 2px;
}


.store-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-top: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #012db2;
  justify-content: flex-start;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  color: #012db2;
}

/* 质保编号样式 */
.warranty-number {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: 10px;
  color: #606266;
  cursor: pointer;
  transition: all 0.2s;
  padding: 2px 3px;
  border-radius: 4px;
  background: rgba(1, 45, 178, 0.05);
  width: fit-content;
}

.warranty-number:hover {
  background: rgba(1, 45, 178, 0.1);
  color: #012db2;
}

.warranty-number:active {
  transform: scale(0.98);
}

.copy-icon {
  width: 14px;
  height: 14px;
  margin-left: 6px;
  opacity: 0.7;
}

.warranty-number:hover .copy-icon {
  opacity: 1;
}

.mobile-section {
  background-color: white;
  margin-bottom: 10px;
  margin-top: 20px;
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #ffec01;
}

.section-title-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  gap: 8px;
}

.section-title-block{
  width: 10px;
  height: 25px;
  background-color: #ffec01;
}

.section-title-contact {
  font-size: 20px;
  color: #012db2;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  font-weight: bold;

  margin: 0;
  padding: 0;
  border: none;
}


.section-title {
  font-size: 18px;
  color: #000000;
  margin-bottom: 0px;
  padding-bottom: 5px;
  font-weight: bold;
}

.section-title-en{
  font-size: 14px;
  color: #000000;
  font-weight: 200;
}


.contact-info {
  margin-top: 15px;
}


.info-item img {
  width: 80%;
  height: auto;
  object-fit: contain;
}

.contact-btn {
  width: 100%;
  padding: 12px;
  background-color: #ffec01;
  color: #012db2;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.contact-btn:hover {
  background-color: #9b9105;
}

.docs-preview-container {
  height: 80vh;
  overflow: auto;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  padding: 10px;
  background-color: #f5f5f5;
}

.pdf-viewer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pdf-toolbar {
  padding: 8px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  z-index: 1;
}

.pdf-scroll-container {
  flex: 1;
  overflow-y: auto;
  position: relative;
  background: #f9f9f9;
}

.pdf-pages-wrapper {
  padding: 20px;
}

.pdf-page-canvas {
  display: block;
  margin: 0 auto 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
}

.loading-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
  display: flex;
  align-items: center;
}


/* 响应式调整 */
@media (min-width: 375px) {
  
  .project-info h2 {
    font-size: 17px;
  }
}

@media (min-width: 414px) {
  
  .image-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .image-preview-dialog {
    width: 100% !important;
    margin: 0 !important;
    max-height: 100vh;
  }
  
  .preview-container {
    height: 80vh;
  }
}
</style>